import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { superAdminDashboardRequirementDetails } from "../common/allLinks";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
  { value: "Skill Name 11", label: "Skill Name 11" },
  { value: "Skill Name 22", label: "Skill Name 22" },
  { value: "Skill Name 33", label: "Skill Name 33" },
];

export default function SuperAdminDashboardClientDetailsHistory() {
  return (
    <>
      <table className="mt-sa-client-details-req-history-table">
        <thead>
          <tr>
            <th>Requirement Title</th>
            <th>No of Resources</th>
            <th>Location</th>
            <th>Rate</th>
            <th>Key Skills</th>
            <th>Requested by</th>
          </tr>
        </thead>
      </table>
      <table className="mt-sa-client-details-req-history-table">
        <tbody>
          {[1, 2].map((data, index) => (
            <tr key={index}>
              <td>
                <Link to={superAdminDashboardRequirementDetails}>
                  <p className="font-24-NunitoSans-600 mb-17 mt-sa-client-details-req-history-table__text4">
                    3 MERN Stack Developers
                  </p>
                </Link>
                <p className="font-16-NunitoSans-600 mb-17 mt-sa-client-details-req-history-table__text1">
                  <img src="/img/desktop/icons/gray-calendar-icon.svg" alt="" />
                  Posted on 12/2/21
                </p>
                <p className="font-16-NunitoSans-600 mb-17 mt-sa-client-details-req-history-table__text1">
                  <img src="/img/desktop/icons/gray-status-icon.svg" alt="" />
                  Status : Fulfilled
                </p>
              </td>
              <td>
                <p className="font-16-NunitoSans-600 mt-sa-client-details-req-history-table__text1">
                  <img
                    src="/img/desktop/icons/gray-two-people-icon.svg"
                    alt=""
                  />
                  3 Resources Required
                </p>
              </td>
              <td>
                <p className="font-16-NunitoSans-600 mt-sa-client-details-req-history-table__text1">
                  <img src="/img/desktop/icons/gray-location-icon.svg" alt="" />
                  Remote
                </p>
              </td>
              <td>
                <p className="font-16-NunitoSans-600 mt-sa-client-details-req-history-table__text1">
                  <img src="/img/desktop/icons/gray-dollar-icon.svg" alt="" />
                  24 /Hr /Resource
                </p>
              </td>
              <td>
                <DisplaySelectedOptionsList
                  displayListSelected={optionsSkill}
                  isDisplayRemoveIcon={false}
                />
              </td>
              <td>
                {[1, 2, 3, 4, 5, 6].map((data, index) => (
                  <Fragment key={index}>
                    <span className="font-16-NunitoSans-600 mt-sa-client-details-req-history-table__text2">
                      AgencyName
                    </span>
                    <span className="font-16-NunitoSans-600 mt-sa-client-details-req-history-table__text3">
                      ,
                    </span>
                  </Fragment>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
